// frontend/src/components/UI/Footer.js

import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
} from 'react-icons/fa'; // oder eigene SVGs verwenden

const Footer = () => {
  return (
    <footer className="bg-white shadow mt-8">
      <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row justify-between items-center">
        <div className="mb-2 md:mb-0 space-x-4">
          <Link to="/imprint" className="text-sm text-gray-600 hover:underline">
            Impressum
          </Link>
          <Link
            to="/privacy"
            className="text-sm text-gray-600 hover:underline"
          >
            Datenschutz
          </Link>
          <Link
            to="/terms"
            className="text-sm text-gray-600 hover:underline"
          >
            AGB
          </Link>
        </div>
        <div className="flex space-x-4">
          {/* Instagram */}
          <a
            href="https://instagram.com/entecity.ch"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram className="w-6 h-6 text-gray-600 hover:text-gray-800" />
          </a>
          {/* TikTok */}
          <a
            href="https://tiktok.com/@entecity"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTiktok className="w-6 h-6 text-gray-600 hover:text-gray-800" />
          </a>
          {/* WhatsApp (z.B. WA.me-Link) */}
          <a
            href="https://wa.me/41796605151"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp className="w-6 h-6 text-gray-600 hover:text-gray-800" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
